import React from 'react';
import styles from './ChatHeader.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Tooltip from 'component/Custom/tooltip/Tooltip';

const ChatHeader = ({ handleExpand, isExpanded, title, config, onNewChat }) => {
  return (
    <div
      className={`${styles['chat-header']} ${
        isExpanded ? styles['expand'] : styles['collapse']
      }`}
      onClick={!isExpanded ? handleExpand : () => {}}
    >
      <div className={styles['navigation-container']}>
        <div
          className={`${styles['navigation']} ${
            isExpanded ? styles['expand'] : styles['collapse']
          }`}
        >
          {!isExpanded ? (
            <div className={styles['left-container']}>
              <SvgWithBranding color="white" type={config.sideSvg ?? 'flow'} />
              {title ? <p>{title ?? 'Workflows'}</p> : null}
            </div>
          ) : (
            <div className={styles['left-container']}> </div>
          )}

          {config ? (
            isExpanded ? (
              <div className={styles['header-actions']}>
                <Tooltip content="New Chat">
                  <SvgWithBranding
                    type="refetchSvg"
                    className={`${styles['svg']} ${config?.className}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      onNewChat();
                    }}
                  />
                </Tooltip>
                <Tooltip content="Close">
                  <SvgWithBranding
                    type={config?.exitSvg ?? 'chat-bart'}
                    className={`${styles['svg']} ${config?.className}`}
                    onClick={handleExpand}
                  />{' '}
                </Tooltip>
              </div>
            ) : null
          ) : (
            <SvgWithBranding type={'chat-bart'} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
